import { render, staticRenderFns } from "./p11.vue?vue&type=template&id=33148122&scoped=true&"
import script from "./p11.vue?vue&type=script&lang=js&"
export * from "./p11.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33148122",
  null
  
)

export default component.exports